import Keycloak from "keycloak-js";
 
export const urlMap = new Map<string, string>([
    ['http://localhost:3000', 'http://localhost:8081/auth'],
    ['https://staging-app.billowpay.it', 'https://staging-auth.billowpay.it/auth'],
    ['https://app.billowpay.it', 'https://auth.billowpay.it/auth']
])
 
export const keycloak = new Keycloak({
    realm: "billow",
    url: urlMap.get(window.location.origin)!,
    clientId: "frontend",
})